import { useCallback, useState } from "react";

import { InstructionsIcon } from "icons";
import theme from "theme";
import { colors } from "theme/palette";

import Box from "components/Box";
import Button from "components/Button";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from "components/Dialog";
import Paper from "components/Paper";
import Text from "components/Text";
import Tooltip from "components/Tooltip";

export interface IInstructionsDialogButton {
  children: React.ReactNode;
}
const InstructionsDialogButton = ({ children }: IInstructionsDialogButton) => {
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <>
      <Tooltip title="Instructions" placement="top">
        <Box
          sx={{
            cursor: "pointer",
            display: "flex",
          }}
        >
          <InstructionsIcon
            sx={{
              width: "16px",
              height: "16px",
            }}
            onClick={handleOpen}
          />
        </Box>
      </Tooltip>
      <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
        <DialogTitle sx={{ padding: theme.spacing(2) }}>
          <Paper sx={{ backgroundColor: colors.blue10, borderRadius: "4px" }}>
            <Text variant="h2">Instructions</Text>
          </Paper>
        </DialogTitle>
        <DialogContent sx={{ padding: theme.spacing(1, 3) }}>
          {children}
        </DialogContent>
        <DialogActions sx={{ padding: theme.spacing(2) }}>
          <Button color="primary" onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default InstructionsDialogButton;
